import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { format, parseISO } from 'date-fns';
import type { CellProps } from 'react-table';
import type { Projects } from '@trinity/chat/api/interfaces';
import { MoreHorizontalAnchorSmall } from '@/components/presentation/Anchor';
import { ProjectActionsState } from '@/containers/GroupProject/ProjectActionsContainer';
import { getLocationFor } from '@trinity/chat-components';
import ProjectIcon from '../icons/ProjectIcon';
import { ProjectActionsContextMenuPopper } from './ProjectActionsContextMenu';
import { ProjectPopoverAnchor } from './ProjectPopover';
import { ProjectProgressBar } from './ProjectProgress';
import styles from './style/ProjectsTable.module.css';

type ProjectRow = Projects.FetchProjects.Response['items'][number];

function NameCell({ row: { original: data } }: CellProps<ProjectRow>) {
  const to = getLocationFor.project.root({
    slug: String(data.id),
  });

  return (
    <div className={styles.name}>
      <ProjectIcon
        className={styles.icon}
        projectTypeId={data.projectTypeId} />
      <ProjectPopoverAnchor className={styles.anchor} item={data}>
        <StyledLink to={to}>
          <div className={styles.trunc}>{data.name}</div>
        </StyledLink>
      </ProjectPopoverAnchor>
    </div>
  );

}

const StyledLink = styled(Link)(({ theme }) => ({
  overflow: 'hidden',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));

function CreatedOnCell({ row: { original: data } }: CellProps<ProjectRow>) {
  return format(parseISO(data.createdOn), 'MM/dd/yyyy');
}

function ProgressCell({ row: { original: data } }: CellProps<ProjectRow>) {
  return (
    <div className={styles.progress}>
      {data.metrics &&
        <ProjectProgressBar
          metrics={data.metrics}
          project={data} />}
    </div>
  );
}

function ActionsCell({ row: { original: data } }: CellProps<ProjectRow>) {
  const { id, name, projectStatusId, projectTypeId } = data;

  const project = {
    id,
    name,
    parentId: data.parentId,
    projectStatusId,
    projectTypeId,
  };

  return (
    <ProjectActionsState
      capabilities={data.capabilities}
      // parent={data.parent}
      object={data.object}
      project={project}>
      <ProjectActionsContextMenuPopper
        Anchor={MoreHorizontalAnchorSmall} />
    </ProjectActionsState>
  );
}

export const Cells = {
  Actions: ActionsCell,
  CreatedOn: CreatedOnCell,
  Name: NameCell,
  // Owner: OwnerCell,
  Progress: ProgressCell,
};